import { render, staticRenderFns } from "./ViewImage.vue?vue&type=template&id=50695506&scoped=true"
import script from "./ViewImage.vue?vue&type=script&lang=js"
export * from "./ViewImage.vue?vue&type=script&lang=js"
import style0 from "./ViewImage.vue?vue&type=style&index=0&id=50695506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50695506",
  null
  
)

export default component.exports